import React from 'react'
import { Card, Ribbon } from 'components/elements/Card'
import { SizeMods } from 'components/styles/primitives/modifiers/size'
import { DomainThemeProvider } from 'components/patterns/themes/context/ThemeProvider'
import { StrongMatchOfferTheme } from 'components/domain/search/offers/common/theme/themes'
import { Calculator } from './components/Calculator'
import { ApprovabilityRibbon } from './components/Ribbon'
import { ImposterContainer } from 'components/layout/primitives/Imposter'
import { BlockComponent } from 'lib'
import dynamic from 'next/dynamic'

export interface ApprovabilityWidgetProps {
	mode?: 'contextual' | 'standalone'
}

const Help = dynamic(() => import('./components/Help'))
export const ApprovabilityWidget: BlockComponent<ApprovabilityWidgetProps> = ({ mode = 'standalone' }) => {
	return (
		<DomainThemeProvider theme={StrongMatchOfferTheme}>
			<Card modifiers={SizeMods({ maxWidth: '800px' })}>
				<Ribbon>
					<ApprovabilityRibbon />
				</Ribbon>
				<Card.Body modifiers={ImposterContainer}>
					<Calculator mode={mode} />
					<Help />
				</Card.Body>
			</Card>
		</DomainThemeProvider>
	)
}
